(function (angular) {
    'use strict';

    angular.module('appMessaging')
        /**
         *
         */
        .controller('AuthenticationCtrl',
        ['$scope', 'authenticationService', 'authenticationData', '$stateParams', '$uibModal', '$state', 'growlService', '$uibModalInstance',
            function ($scope, authenticationService, authenticationData, $stateParams, $uibModal, $state, growlService, $uibModalInstance) {

                    $scope.authenticationData = authenticationData;
                    $scope.authentication = angular.copy($scope.authenticationData);
                    $scope.updateAuthData = function(){
                        $scope.authentication = angular.copy($scope.authenticationData);
                    };
                    $scope.cancelAuthUpdate = function(){
                        $uibModalInstance.dismiss('cancel');
                    };
                
                    $scope.updateAuth = function(){
                        authenticationService.setAuthConfig($stateParams.pickedApiSpaceId, $scope.authentication)
                        .then(function(config){
                            $scope.authenticationData = config;
                            $scope.updateAuthData();
                            growlService.success('Auth Config set');
                            $uibModalInstance.close('save');
                        }).catch(function(error){
                            $scope.updateAuthData();
                            growlService.danger("Auth Config wasn't set due to: "+error.statusText);
                        });

                    };
        }]);


})(window.angular);
